import React from 'react';
import { ChevronRight, Clock, ShieldAlert, Stethoscope, TrendingUp } from 'lucide-react';

const TONES = {
  blue: { bg: 'from-[#0C2744] to-[#071B34]', ring: 'ring-[#9AADBE]/40' },
  teal: { bg: 'from-[#0C2744] to-[#F15A22]', ring: 'ring-[#F15A22]/30' },
  amber: { bg: 'from-[#C4A35A] to-[#F15A22]', ring: 'ring-[#C4A35A]/40' },
  rose: { bg: 'from-[#F15A22] to-[#a33a12]', ring: 'ring-[#F15A22]/30' },
};

function KpiTile({ label, value, icon: Icon, hint, tone = 'blue', onClick }) {
  const t = TONES[tone] || TONES.blue;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group text-left rounded-2xl border border-zinc-200 bg-white p-5 hover:shadow-lg transition-all hover:-translate-y-0.5 focus:outline-none focus:ring-2 ${t.ring}`}
      data-testid={`mgmt-kpi-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className={`h-9 w-9 rounded-xl bg-gradient-to-br ${t.bg} text-white grid place-items-center shadow-sm`}>
          <Icon className="h-4 w-4" />
        </div>
        <ChevronRight className="h-4 w-4 text-zinc-300 group-hover:text-zinc-500" />
      </div>
      <div className="text-[10px] font-bold uppercase tracking-widest text-zinc-500 mb-1">{label}</div>
      <div className="text-2xl font-extrabold text-zinc-900" style={{ fontFamily: 'Manrope' }}>{value}</div>
      {hint && <div className="text-[11px] text-zinc-500 mt-1">{hint}</div>}
    </button>
  );
}

const inr = (n) => `₹${(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

export default function ManagementKpiRow({ loading, kpis, scheduleTotal, rangeLabel, onOpen }) {
  const k = kpis || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="mgmt-kpi-row">
      <KpiTile label="Total Visits" value={loading ? '…' : k.total_visits ?? 0}
        icon={Stethoscope} hint={rangeLabel} tone="blue" onClick={() => onOpen('visits')} />
      <KpiTile label="Revenue" value={loading ? '…' : inr(k.revenue_total)}
        icon={TrendingUp} hint={`${k.revenue_txn_count || 0} txns`} tone="teal" onClick={() => onOpen('revenue')} />
      <KpiTile label="Today's Queue" value={loading ? '…' : k.today_queue ?? 0}
        icon={Clock} hint={`${k.today_sessions || 0} sessions`} tone="amber" />
      <KpiTile label="Schedule Rx" value={loading ? '…' : scheduleTotal ?? 0}
        icon={ShieldAlert} hint="H / H1 / X pressure" tone="rose" onClick={() => onOpen('schedule')} />
    </div>
  );
}
